@use "variables" as *;

.list {
  display: flex;
  flex-direction: column;
  margin-bottom: $spacing-xxl !important;
  align-items: center;
  padding: $spacing-m !important;
}

.sectionCard {
  margin: $spacing-s;
  border-radius: 16px !important;
  box-sizing: border-box;
  width: 100%;
}

.listItem {
  padding-left: $spacing-l !important;
  padding-right: $spacing-m !important;
}

.itemTitle {
  font-size: $fontSize-m;
  font-weight: bold;
}
